module.exports = __webpack_public_path__ + "static/media/physical_card.4fb77128.png";